/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import widgetModule from "@stoneage/Overrides/Widgets/Footer/FooterContainer";
import { footerContainerStyles, siteMessages } from "@stoneage/Overrides/Widgets/Footer/FooterContainer";
import color from "@stoneage/XDL/Utilities/color";
import { css } from "styled-components";

footerContainerStyles.footerBanner = {
    css: css`
        ${footerContainerStyles.footerBanner?.css};
        a span {
            color: ${color("common.background", 0.5)} !important;
        }
        .copyright {
            color: ${color("common.background")};
        }
    `,
};

export * from "@stoneage/Overrides/Widgets/Footer/FooterContainer";
export default widgetModule;
